import React, { Component } from 'react';
import _ from 'lodash';

import CheckingSettingForm from '../components/CheckingSettingForm';
import CheckingSettingModel from '../components/CheckingSettingModel';

import { Layout, Button, Row, Col, Input, Icon, message } from 'antd';

class CheckingSettingScreen extends Component {

  state = {    
    dataLoading: false,
    dataAll: null,
    data: null,              
    parkinglocationFormModalVisible: false    
  }

  componentWillMount() {
    this.loadData();
  }

  loadData(parkinglocation) {
    this.setState({
      dataLoading: true
    });
    CheckingSettingModel.get()
      .then(data => {        
        this.setState({
          dataLoading: false,
          dataAll: data,
          data: data
        });   
      });
  }

  onCheckingSettingFormSuccess(form, values) {
    CheckingSettingModel
      .update(this.state.data.id, Object.assign({}, { Data: values }, { Name: this.state.data.Name }))
      .then(() => {
        message.success('Nastavení "Kontroly PO" bylo uloženo!');
      })
      .catch((err) => {
        message.error('Nastavení "Kontroly PO" se nepodařilo uložit!');
      });
  }

  render() {
    return (      
      <Layout.Content style={{ margin: '24px 16px 0' }}>
        <div style={{ padding: 24, background: '#fff', minHeight: 360 }}>
          <h2>Kontrola PO - Nastavení</h2>          
          {this.state.data             
            ? <CheckingSettingForm 
                defaultValues={this.state.data.Data}
                onSuccess={this.onCheckingSettingFormSuccess.bind(this)}/>
            : null}
        </div>
      </Layout.Content>
    );
  }
}

export default CheckingSettingScreen;



// WEBPACK FOOTER //
// ./src/screens/CheckingSettingScreen.js